import { render, staticRenderFns } from "./structureChart.vue?vue&type=template&id=1088a852&scoped=true&"
import script from "./structureChart.vue?vue&type=script&lang=js&"
export * from "./structureChart.vue?vue&type=script&lang=js&"
import style0 from "./structureChart.vue?vue&type=style&index=0&id=1088a852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1088a852",
  null
  
)

export default component.exports